import {createAction} from 'redux-act';

// login
export const login = createAction('Login');
export const loginSuccessful = createAction('Login successful');
export const loginFailed = createAction('Login error');
export const clearLoginError = createAction('Clear login error');

export const challengeRequired = createAction('Challenge required');

export const respondNewPasswordChallenge = createAction("Respond new password challenge");
export const respondNewPasswordChallengeSuccessful = createAction("Respond new password challenge successful");

export const logout = createAction("Logout");
export const logoutSuccessful = createAction("Logout successful");

export const refreshToken = createAction("Refresh token");
export const refreshTokenSuccessful = createAction("Refresh token successful");


export const forgotPassword = createAction("Forgot password")
export const forgotPasswordSubmit = createAction("Forgot password submit successful");
export const confirmForgotPassword = createAction("Confirm forgot password");
export const clearForgotPassword = createAction("Clear forgot password");
export const clearForgotPasswordForm = createAction("Clear forgot password form");


